// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"439":"6eb5fe53","453":"4b064d4b"}[chunkId] + ".chunk.js";
};